<template>
  <div class="pt-6">
    {{theme}}
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Exam',
  data () {
    return {
      session: this.$session.getAll(),
      theme: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.theme = this.$store.getters['shopStore/GET_THEME']
    await this.getBlog()
  },
  methods: {
    ...mapActions('shopStore', ['getBlog'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Example.vue